export default __webpack_public_path__ + "static/media/Rectangle_72.1a513679.png";